import React, { useState } from "react";
import PT_From from "./pt_From/PT_From";
import PT_table from "./pt_table/PT_table";
import { FixIDS } from "../../../../../../../utils/fixIDS";
import { useSelector } from "react-redux";

function PT({ validitydetails, setCurrentPage, currentPage ,openDeleteModal}) {
  const [showTable, setShowTable] = useState(false);

  const permissions = useSelector((state) => state.auth.permissions);
                                              
  const haveReadPermission = permissions?.includes(FixIDS.ensuring_the_validity.List);
  const haveAddPermission = permissions?.includes(FixIDS.pt.Add); //form

  return (
    <>
      <div className="imperiality_Form_div">
        { haveAddPermission && <PT_From validityTypeId={7} onProceed={() => setShowTable(true)} />}
      </div>

      {/* {showTable && ( */}
      <div className="imperiality_table_div">
        { haveReadPermission && <PT_table
         openDeleteModal={openDeleteModal}
          validitydetails={validitydetails}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
          validityTypeId={7}
        />}
      </div>
      {/* )} */}
    </>
  );
}

export default PT;
